import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'

const PosleslovView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ХОРАТА РАЗКАЗИ</h1>
                        <p className="lead">ПОСЛЕСЛОВ</p>
                    </div>
                    <p>
                        Любомъдри читателю, Големият разказ „Царството „Паисиада" и хората разкази", който разправям отколе, вече съзира
                        края си. Но преди да догоним заедно заключителния му ред, ще ти подаря и още един духовен урок. Урокът, който
                        преподавам на моите студенти, и който бих искала да споделя и с теб, ни учи, че Паисиевата История е онази
                        възрожденска ръкописна книга – национална институция, която не съдържа единствено Зографската чернова от 1762 г., а
                        съдържа и всички останали нейни ръкописни преписи и преправки:
                    </p>
                    <ul>

                        <li>както съхранените;</li>
                        <li>така и похитените от колекционери-ценители, които вероятно все още са някъде по света, в богати частни
                            книгохранилища;</li>
                        <li>така и изгубените.</li>
                    </ul>

                    <p>
                        Все нови и нови обрамчващи истории за историята на „Паисиада"… Като български учен, посветил професионалния си път
                        на изучаването на Големите разкази на Българското възраждане, добре зная, че „История славянобългарска" е опастрила
                        достолепната четвъртхилядолетна памет за себе си не толкова поради Зографската чернова от 1762 г., колкото поради
                        завръзките, кулминациите и развръзките на обрамчващите я нови Аз-истории на хората разкази – духовните посланици на
                        „Царството Паисиада". В „Паисиада" подобно на „Хиляда и една нощ" всеки следващ от хоратаразкази разказва:
                    </p>
                    <ul>

                        <li>старата история;</li>
                        <li>разказва новата история;</li>
                        <li>отваря и още по-нова история.</li>
                    </ul>

                    <p>
                        Така всяка обрамчваща история поема функцията да бъде:
                    </p>
                    <ul>

                        <li>и разказ за протографа (първоизвора) „История славянобългарска";</li>
                        <li>и разказ за извода, от който се преписва;</li>
                        <li>и разказ за новия препис или преправка;</li>
                        <li>и разказ за читателите, притежателите, ползвателите на един или друг препис или преправка, които са оставяли
                            приписки по ръкописните им страници;</li>
                        <li>и разказ, който поражда нов препис или преправка;</li>
                        <li>и разказ за протографа Спиридонова история, когато се изготвя преправка;</li>
                        <li>и разказ за историята на Големия разказ „Царството Паисиада" и хоратаразкази".</li>
                    </ul>

                    <p>
                        А историите на хоратаразкази, които се нижат 117 години и разказват „Паисиада" на онези възрожденски българи,
                        доказват, че актът на обрамчването, т.е. преписването и преправянето на „История славянобългарска", е получил
                        върховно утвърждение:
                    </p>
                    <ul>

                        <li>защото преписвам-и-преправям е равнозначно на живея;</li>
                        <li>защото всеки нов разказ <em>на </em>и <em>за </em>хората разкази означава ЖИВОТ ЗА „ПАИСИАДА", а отсъствието на
                            разказ би белязало нейната СМЪРТ.</li>
                    </ul>

                    <p>
                        Ако ние, съвременните българи, които сме само временни поданици на „Новата цивилизация" и „Третата вълна" (образите
                        са на Тофлър 2002), се възползваме от могъщите възможности на технизираното ни времеи осъзнаем, че именно СЕГА, А
                        НЕ УТРЕ ИЛИ ПО-НАТАТЪК, трябва да издадем всеки съхранен препис и всяка опазена преправка, то тогава „Паисиада" ще
                        продължава да живее и след нас. И тогава животът на хората разкази от условното „Царството Паисиада":
                    </p>
                    <p>

                        <em>Стойко йерей, поп Алекси Попович Велкович, монах Никифор Рилец, поп Стоян Кованлъшки, Дойно Граматик, поп
                            Пунчо, отец Панталеймон проигумен Хилендарски, Влад Поппетков Гладичов, даскал Никола Поплазаров, монах Паисий
                            Рилски, монах Панталеймон, даскал Георги, даскал Стефан поп Зотов, даскал Сава Доброплодни, Даскал Тодор
                            Пирдопски, Петко Р. Славейков, Христо Драганов, Кънчо Стоянович Бакал, преписал с иждивението на Стоянчо Пенев
                            Ахтар, Тодор Шишков, поп Василий Мануилов, даскал Драгия Ненов, монах Паисий Николаевич, поп Йоаникия Петкович,
                            йеромонах Харитон, даскал Найден Геров, архимандрит Онуфрий Попович Хилендарски, Васил Станкович, Даскал
                            Димитър Миладинов, опълченеца Димитър Оджаков, поп Костадин Чучулайн, дон Едуардо Валпа, Лаврен Кьосестоянов,
                            Петър Балсамаджиев, търговецът Васил Априлов, проф. Николай Мурзакевич, проф. Владимир Ламански,</em>
                    </p>
                    <p>
                        ще да е имал смисъл. И заради Тях, а и заради нас самите.
                    </p>
                    <p>
                        ПРЕДАЙ НАТАТЪК!
                    </p>
                </main>
            </div>
        </MainLayout>
    )
}

PosleslovView.propTypes = {

}

export default PosleslovView



// WEBPACK FOOTER //
// ./src/views/Posleslov/index.jsx